import PlaceholderImage from './PlaceholderImage.jsx'

export default function FeatureBlock({ feature, reversed = false, imgSrc }) {
  const { title, text, image, imageAlt, width, height } = feature

  return (
    <div className={`flex flex-col gap-12 items-center ${reversed ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
      <div className="flex-1 space-y-4">
        <h3 className="font-display font-semibold text-2xl md:text-3xl text-kart-night leading-tight">
          {title}
        </h3>
        <p className="text-slate-600 text-lg leading-relaxed">{text}</p>
      </div>
      <div className="flex-1 w-full">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={imageAlt}
            width={width}
            height={height}
            loading="lazy"
            decoding="async"
            className="w-full rounded-2xl object-cover"
          />
        ) : (
          <PlaceholderImage
            filename={image}
            alt={imageAlt}
            width={width}
            height={height}
            className="w-full"
          />
        )}
      </div>
    </div>
  )
}
